import React from 'react';

import { Listbox } from '@zillow/constellation';
import type { Section } from '../../models';

type Props = {
  option1FieldName: string;
  option1Header: string;
  option1Content: string;
  option2FieldName: string;
  option2Header: string;
  option2Content: string;
  section: Section;
  setSectionValues: (keyValuePairs: object) => void;
  initialState?: object;
};

export default function RadioListBox({
  option1FieldName,
  option1Header,
  option1Content,
  option2FieldName,
  option2Header,
  option2Content,
  section,
  setSectionValues,
  initialState,
}: Props): JSX.Element {
  function onOptionChange(value: string): void {
    setSectionValues({
      [option1FieldName]: value === option1FieldName,
      [option2FieldName]: value === option2FieldName,
      ...initialState,
    });
  }

  return (
    <Listbox
      value={
        section.getFieldValue(option1FieldName)
          ? option1FieldName
          : section.getFieldValue(option2FieldName)
            ? option2FieldName
            : ''
      }
      onChange={onOptionChange}
      appearance="radio"
      options={[
        {
          value: option1FieldName,
          label: option1Header,
          meta: option1Content,
          disabled: section.isFieldDisabled(option1FieldName),
        },
        {
          value: option2FieldName,
          label: option2Header,
          meta: option2Content,
          disabled: section.isFieldDisabled(option2FieldName),
        },
      ]}
    />
  );
}
